import { render, staticRenderFns } from "./record.vue?vue&type=template&id=f86d1254&scoped=true&"
import script from "./record.vue?vue&type=script&lang=js&"
export * from "./record.vue?vue&type=script&lang=js&"
import style0 from "./record.less?vue&type=style&index=0&id=f86d1254&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86d1254",
  null
  
)

export default component.exports